export function getRadioGroupValue(selectorOrElements) {
  const radioButtons =
    typeof selectorOrElements === 'string'
      ? document.querySelectorAll(radioButtons)
      : selectorOrElements;

  if (radioButtons) {
    for (const radio of radioButtons) {
      if (radio.checked) {
        return radio.value;
      }
    }
  }

  return null;
}

export function onRadioGroupValueChange(
  selectorOrElements,
  callback = (value) => {},
) {
  const radioButtons =
    typeof selectorOrElements === 'string'
      ? document.querySelectorAll(radioButtons)
      : selectorOrElements;

  radioButtons.forEach((radio) => {
    radio.addEventListener('change', (e) => {
      callback(e.target.value);
    });
  });
}
